import { Box} from "@mui/material";
import { BannerHome } from "../../components/home/Banner";
import { QuienesSomosHome } from "../../components/home/Quienes-Somos";
import { ValoresHome } from "../../components/home/Valores";
import { NoticiasHome } from "../../components/home/Noticas";
import { ContactoHome } from "../../components/home/Contacto";
import SEO from "../../components/common/seo";
const Home = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection:'column',
        bgcolor: "#F4F6F8",
      }}
    >
       <SEO
        title="Colegio Antilén | Educación Integral"
        description="Colegio Antilén entrega una educación integral, formando estudiantes con valores, conocimientos y habilidades para su futuro."
        keywords="Colegio Antilén, colegio, educación, enseñanza básica, formación integral"
      />
     <BannerHome/>
     <QuienesSomosHome/>
     <ValoresHome/>
     <NoticiasHome/>
    <ContactoHome/>
    </Box>
  );
};

export default Home;